import { Menu, MenuItem } from '@material-ui/core';
import CustomRouterLink from 'components/CustomRouterLink/CustomRouterLink';
import { LogoutRoutePath } from 'library/Routes';
import React from 'react';
import { connect } from 'react-redux';
import { IAuthReducer } from 'store/modules/AuthReducer';
import { IReducer } from 'store/Reducer';

export interface IUserMenu {
  mostrarSaudacao?: boolean,
  anchorEl: Element | null,
  onClose: Function,
  auth: IAuthReducer,
}

const UserMenu = ({ mostrarSaudacao, auth, anchorEl, onClose }: IUserMenu) => {

  const getUserName = () => {
    if (auth && auth.usuario) {
      return auth.usuario.nome.split(' ')[0];
    }
  }

  return (
    <Menu
      anchorEl={ anchorEl }
      open={ anchorEl ? true : false }
      onClose={ () => onClose() }
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {
        mostrarSaudacao ? (
          <MenuItem onClick={ () => onClose() }>Olá { getUserName() }</MenuItem>
        ) : null
      }
      <MenuItem component={ CustomRouterLink } onClick={ () => onClose() } to={LogoutRoutePath}>Sair</MenuItem>
    </Menu>
  );
}

const mapStateToProps = (state:IReducer) => {
  return {
    auth: state.auth
  };
};

export default connect(mapStateToProps)(UserMenu);